import { showConfirmModal } from "./custom_confirm"
import { escapeHTML } from "./gl_modal_shell"

// The one popup an agent reads before something that bills their CRM wallet
// turns ON (#20129 / #20242, owner-approved mockup 2026-10-30): the server's
// Voice::TurnOnWarning JSON { title, paragraphs: [{ label, text }],
// confirm_label, cancel_label } — the agent's own price and the consent note.
// Resolves true on "Turn On", false on "Keep Off"; rejects if the dialog
// cannot open (callers fail closed). Read by switch_on_warning_controller.js
// (Paid Call Features switches) and submit_on_warning_controller.js (accepting
// an agency owner's recording request).
export function showTurnOnWarning (warning) {
  return showConfirmModal("", {
    title: warning.title,
    variant: "warning",
    bodyHTML: turnOnWarningBody(warning),
    confirmText: warning.confirm_label || "Turn On",
    cancelText: warning.cancel_label || "Keep Off",
    confirmClass: "gl-btn gl-btn-primary",
  })
}

export function turnOnWarningBody (warning) {
  const paragraphs = warning.paragraphs || []
  return paragraphs.map((paragraph, index) => {
    const spacing = index === paragraphs.length - 1 ? "mb-0" : "mb-2"
    const label = paragraph.label ? `<strong>${escapeHTML(paragraph.label)}:</strong> ` : ""
    return `<p class="gl-modal-text ${spacing}">${label}${escapeHTML(paragraph.text)}</p>`
  }).join("")
}
